import React, {Fragment} from 'react';
import {find, mean, round} from 'lodash';
import Icon from '../../../../core/scripts/components/Icon';

export function BigTable(props) {
  const data = props.apidata;
  const id_list = props.idname;
  const placeholder = "Lädt...";
  let avg, maxTemp, maxTemp_record, minTemp, minTemp_record, maxSnow, maxSnow_record;
  if (data!= null && id_list != null) {
    avg = formatTemp(round(mean(data.all_averages),1))+ '\u00A0°C';
    maxTemp = formatTemp(data.maxTemp.value)+ '\u00A0°C';
    maxTemp_record = getStationName(data.maxTemp.station_id, id_list) + ", " + getDatum(data.maxTemp.timestamp);
    minTemp = formatTemp(data.minTemp.value)+ '\u00A0°C';
    minTemp_record = getStationName(data.minTemp.station_id, id_list) + ", " + getDatum(data.minTemp.timestamp);
    maxSnow = data.maxSchnee.value+ '\u00A0cm';
    maxSnow_record = getStationName(data.maxSchnee.station_id, id_list) + ", " + getDatum(data.maxSchnee.timestamp);
  }
  else {
    avg = placeholder;
    maxTemp = placeholder;
    maxTemp_record = placeholder;
    minTemp = placeholder;
    minTemp_record = placeholder;
    maxSnow = placeholder;
    maxSnow_record = placeholder;
  }

  return (
    <Fragment>
        <div className="current-winter__data-headrow">
          <span className="current-winter__data-headrow-label">Temperatur</span>
          <span className="current-winter__data-headrow-label old">seit 1960</span>
        </div>
        <div className="current-winter__data-temperature">
          <Icon type="temperature"/>
          <div className="current-winter__data-row tmid">
            <span className="current-winter__data-row-label">Mittlere</span>
              <span className="current-winter__data-row-value">{avg}</span>
            <span className="current-winter__data-row-value old">-0,07&nbsp;°C
            </span>
          </div>
          <div className="current-winter__data-row thigh">
            <span className="current-winter__data-row-label">Wärmste
              <span className="current-winter__data-row-record">{maxTemp_record}</span>
            </span>
            <span className="current-winter__data-row-value">{maxTemp}</span>
            <span className="current-winter__data-row-value old">22&nbsp;°C
              <span className="current-winter__data-row-record">2008</span>
            </span>
          </div>
          <div className="current-winter__data-row tlow">
            <span className="current-winter__data-row-label">Kälteste
              <span className="current-winter__data-row-record">{minTemp_record}</span>
            </span>
            <span className="current-winter__data-row-value">{minTemp}</span>
            <span className="current-winter__data-row-value old">-33,5&nbsp;°C
              <span className="current-winter__data-row-record">1963</span>
            </span>
          </div>
        </div>
        <div className="current-winter__data-snow">
          <Icon type="snow"/>
          <div className="current-winter__data-row snow">
            <span className="current-winter__data-row-label">max. Schneehöhe
              <span className="current-winter__data-row-record">{maxSnow_record}</span>
            </span>
            <span className="current-winter__data-row-value">{maxSnow}</span>
            <span className="current-winter__data-row-value old">650&nbsp;cm
              <span className="current-winter__data-row-record">1981</span>
            </span>
          </div>
        </div>
    </Fragment>
  );
}

export function Stand(props) {
  const data = props.apidata;
  if(data!= null) {
    var datum = data.grabbed_at.substring(0,10).split("-");
    var stunde = data.grabbed_at.substring(11,13);
    stunde = stunde < 24 ? parseInt(stunde) + 1 : "0";
    var update = datum[2] + "." + datum[1] + "." + datum[0] +", " + stunde + " Uhr";
    return (
      <Fragment>
         -
      </Fragment>
    );
  }
  else {
    return (
      <Fragment>
          -
      </Fragment>
    );
  }
}
//<time className="update">Letzes Update: {update}</time> 
//helper
function getStationName(id, id_list) {
  const object = find(id_list, function(o) { return o.STATIONS_ID == id; });
  return object.name;
}
function getDatum(date) {
  date = new Date(date);
  const day = (date.getDate() < 10 ? '0' : '') + date.getDate();
  const month = ((date.getMonth() + 1) < 10 ? '0' : '') + (date.getMonth() + 1);
  return day + "." + month + "." + date.getFullYear();
}
function formatTemp(number) {
  if(number >= 0) {
    return number.toString().replace(".", ",");
  } else {
    return "-" + Math.abs(number).toString().replace(".", ",");
  }
}
